import { auth } from './metas'
import RouteDelegate from './RouteDelegate'
const Dashboard = () => import('@/pages/Dashboard')
const PlatformRevenues = () => import('@/pages/PlatformRevenues')
const TeamAvailabilities = () => import('@/pages/TeamAvailabilities')
const Gains = () => import('@/pages/ExpertGains')
const Statistics = () => import('@/pages/Statistics')
const Accounting = () => import('@/pages/Accounting')

export default [
  {
    path: '/',
    component: RouteDelegate,
    meta: auth,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'revenues',
        name: 'PlatformRevenues',
        component: PlatformRevenues
      },
      {
        path: 'gains',
        name: 'Gains',
        component: Gains
      },
      {
        path: 'availabilities',
        name: 'Availabilities',
        component: TeamAvailabilities,
        props: route => ({
          interval: route.query.interval
        })
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: Statistics
      },
      {
        path: 'accounting',
        name: 'Accounting',
        component: Accounting
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboards.route.js